import { Link } from "react-router-dom"

export default function NotFoundPage() {
  return (
    <section className="app-page flex flex-col items-center gap-4 text-center">
      <h1 className="app-txt-h1">페이지를 찾을 수 없습니다.</h1>
      <p className="app-txt-body1 text-app-text-300">
        요청하신 페이지가 삭제되었거나 주소가 변경되었습니다.
      </p>
      <Link
        to="/"
        className="focus-ring app-btn app-btn-primary mt-2"
      >
        홈으로
      </Link>
    </section>
  )
}
